import * as stylex from '@stylexjs/stylex';
import '../styles/tokens.stylex';
import { borderRadius, color, shadow, spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { PageSectionsContentSectionContentBlocksVideoTestimonialsTestimonial } from '@/tina/__generated__/types';
import { RichText } from './RichText';
import { tinaField } from 'tinacms/dist/react';
import { VideoHandler } from './VideoDialog/VideoHandler';
export interface TestimonialListProps {
  videoTestimonials: VideoTestimonialProps[];
}
interface VideoTestimonialListProps {
  data: PageSectionsContentSectionContentBlocksVideoTestimonialsTestimonial[];
}
export interface VideoTestimonialProps {
  name: string;
  position: string;
  description?: string;
}
export function VideoTestimonialList(props: VideoTestimonialListProps) {
  return <div className="xrvj5dj x1717udv x1mhrlx8 x1y6fwsi x8053dw">
      {props.data.map((testimonial, i) => {
      const key = `${i}-${testimonial.name.replace(/\s/, '')}`;
      return <VideoTestimonial data={testimonial} key={key} name={key} />;
    })}
    </div>;
}
export function VideoTestimonial({
  data,
  name
}: {
  data: PageSectionsContentSectionContentBlocksVideoTestimonialsTestimonial;
  name: string;
}) {
  return <article>
      <VideoHandler data={data} />
      <div className="xrvj5dj x3ybb33 x1o4oh2x">
        <div>
          <h2 {...stylex.props([typography.heading2])} data-tina-field={tinaField(data, 'name')}>
            {data.name}
          </h2>
          <p {...stylex.props([typography.body])} data-tina-field={tinaField(data, 'position')}>
            {data.position}
          </p>
        </div>
        <div data-tina-field={tinaField(data, 'description')}>
          <RichText>{data.description}</RichText>
        </div>
      </div>
    </article>;
}